module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige14-018cbe57110348879c789b2d93f950ac.jpg";